import { render, staticRenderFns } from "./PaidAbsentDay.vue?vue&type=template&id=65487bbe&scoped=true"
import script from "./PaidAbsentDay.vue?vue&type=script&lang=ts"
export * from "./PaidAbsentDay.vue?vue&type=script&lang=ts"
import style0 from "./PaidAbsentDay.vue?vue&type=style&index=0&id=65487bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65487bbe",
  null
  
)

export default component.exports